import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { Grid, MenuItem } from '@material-ui/core';
import {
  UploadComponent,
  ButtonGroup,
  InputField,
  Toggle,
  Divider,
  ButtonComponent,
  TableView,
} from '..';
import FantasySettings from '../Fantasy/FantasySettings';

import { useStyles } from '../Fantasy/styles';

class FantasyEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      ready: false,
      pool_size: null,
      draft_size: null,
      category: [],
    };
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {}

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**RENDER METHOD */
  render() {
    const { classes, isEdit } = this.props;

    return (
      <Grid>
        <FantasySettings
          current_tab={this.props.current_tab}
          onClick={this.props.onClick}
          chapter_settings={this.props.chapter_settings}
          isEdit={true}
        />
        <Divider />

        {this.props.chapter_settings &&
        this.props.chapter_settings[this.props.current_tab] &&
        this.props.chapter_settings[this.props.current_tab][
          'fantasy_questions'
        ] &&
        this.props.chapter_settings[this.props.current_tab]['fantasy_questions']
          .length > 0 ? (
          <TableView
            table_headers={{
              id: '#',
              option_id: 'Option id',
              option: 'Option',
              quarter_id: 'Chapter',
              group_id: 'Group',
              external_player_id: 'API Player ID',
              bkgd_hex_code: 'Hex Code',
            }}
            table_data={
              this.props.chapter_settings &&
              this.props.chapter_settings[this.props.current_tab] &&
              this.props.chapter_settings[this.props.current_tab][
                'fantasy_questions'
              ]
                ? this.props.chapter_settings[this.props.current_tab][
                    'fantasy_questions'
                  ]
                : []
            }
          />
        ) : (
          ''
        )}
        <br />
        <ButtonGroup {...this.props} />
        <br />
      </Grid>
    );
  }
}

FantasyEdit.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(FantasyEdit);
